import { createFileRoute } from '@tanstack/react-router'
import { StoreHoursPage } from '~/components/routes/store-dashboard/hours/store-hours-page'
import { withRoutePermissions } from '~/utils/rbac'
import { storeHoursSearchSchema } from './-search-schema'

function StoreHoursRoute() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return <StoreHoursPage search={search} navigate={navigate} />
}

export const Route = createFileRoute('/_authenticated/dashboard/hours')({
  component: StoreHoursRoute,
  staticData: { permission: ['read', 'dashboard.dashboard.global-indicators'] },
  validateSearch: storeHoursSearchSchema,
})

withRoutePermissions(Route)
